import React from 'react';
import cn from 'clsx';
import css from 'styled-jsx/css';
import I18nLink from '~/components/I18nLink';
import themeVariables from '~/shared/themeVariables';

const ButtonBecomeCreator = ({ t, className, style, title }) => {
  return (
    <I18nLink href="/creator-registration">
      <a
        className={cn('button-become-creator', className)}
        style={style}
        target="_blank"
      >
        {title || t('become_creator_now')}
        <style jsx>{styles}</style>
      </a>
    </I18nLink>
  );
};

const styles = css`
  .button-become-creator {
    outline: none;
    border: 0;
    font-size: ${themeVariables.fontSize.medium}px;
    background: #3fcd89;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 4px;
    padding: 0 ${themeVariables.space.base}px;
    color: #fff;
    font-weight: 600;
    width: fit-content;
    height: 44px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    text-decoration: none;
  }

  .button-become-creator:hover {
    opacity: 0.8;
  }

  @media (max-width: ${themeVariables.breakpoints.tabletS.maxWidth}px) {
    .button-become-creator {
      width: 100%;
    }
  }
`;

export default ButtonBecomeCreator;
